module.exports = __webpack_public_path__ + "static/jcu-mysafety-logo-719579f50caa8360b7a00f29e6979e07.png";